import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UnassignProductAccountEntitlementsResultModal} from './unassign-product-account-entitlements.result.modal';
import {
    clearResult,
    selectUnassignProductAccountEntitlementsBulkUuid,
    selectUnassignProductAccountEntitlementsShown,
    selectUnassignProductAccountEntitlementsTask,
} from './unassign-product-account-entitlements.slice';


export const UnassignProductAccountEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectUnassignProductAccountEntitlementsBulkUuid}
        actionTaskSelector={selectUnassignProductAccountEntitlementsTask}
        actionShownSelector={selectUnassignProductAccountEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <UnassignProductAccountEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
